import axios from 'axios';
import {
  GET_TAGS,
  GET_TAGS_LIST,
  GET_TAGS_MINIMAL,
  GET_TAG,
  ADD_TAG,
  DELETE_TAG,
  UPDATE_TAG,
  TAGS_LOADING,
  TAG_LOADING,
  CLEAR_CURRENT_TAG,
  SET_TAGS_PAGE
} from './types';
import { tokenConfig } from './authActions';
import { returnErrors } from './errorActions';

// Get lightweight tags list with pagination and filtering (for table display)
export const getTagsList = (page = 1, limit = 10, filters = {}) => (dispatch, getState) => {
  dispatch(setTagsLoading());

  // Build query string with pagination and filters
  let queryParams = `page=${page}&limit=${limit}`;
  
  if (filters.title && filters.title.length > 0) {
    const encodedTitles = filters.title.map(title => encodeURIComponent(title));
    queryParams += `&title=${encodedTitles.join(',')}`;
  }
  if (filters.createdBy && filters.createdBy.length > 0) {
    const encodedCreators = filters.createdBy.map(name => encodeURIComponent(name));
    queryParams += `&createdBy=${encodedCreators.join(',')}`;
  }

  axios
    .get(`/api/tags/list?${queryParams}`, tokenConfig(getState))
    .then(res => dispatch({ type: GET_TAGS_LIST, payload: res.data }))
    .catch(err => dispatch(returnErrors(err.response?.data, err.response?.status)));
};

// Get single tag by ID (for view/edit pages)
export const getTag = (id) => (dispatch, getState) => {
  dispatch(setTagLoading());
  axios
    .get(`/api/tags/${id}`, tokenConfig(getState))
    .then(res => dispatch({ type: GET_TAG, payload: res.data }))
    .catch(err => dispatch(returnErrors(err.response?.data, err.response?.status)));
};

// Clear current tag
export const clearCurrentTag = () => {
  return { type: CLEAR_CURRENT_TAG };
};

// Get minimal tags list (for dropdowns/selectors - returns only _id and title)
export const getTagsMinimal = () => (dispatch, getState) => {
  dispatch(setTagsLoading());
  axios
    .get('/api/tags/minimal', tokenConfig(getState))
    .then(res => dispatch({ type: GET_TAGS_MINIMAL, payload: res.data }))
    .catch(err => dispatch(returnErrors(err.response?.data, err.response?.status)));
};

// DEPRECATED: Use getTagsList() instead
export const getTags = () => (dispatch, getState) => {
  dispatch(setTagsLoading());
  axios
    .get('/api/tags', tokenConfig(getState))
    .then(res => dispatch({ type: GET_TAGS, payload: res.data }))
    .catch(err => dispatch(returnErrors(err.response.data, err.response.status)));
};

export const addTag = tag => (dispatch, getState) => {
  axios
    .post('/api/tags', tag, tokenConfig(getState))
    .then(res => dispatch({ type: ADD_TAG, payload: res.data }))
    .catch(err => dispatch(returnErrors(err.response.data, err.response.status)));
};

export const updateTag = (id, tag) => (dispatch, getState) => {
  axios
    .put(`/api/tags/${id}`, tag, tokenConfig(getState))
    .then(res => dispatch({ type: UPDATE_TAG, payload: res.data }))
    .catch(err => dispatch(returnErrors(err.response.data, err.response.status)));
};

export const deleteTag = id => (dispatch, getState) => {
  axios
    .delete(`/api/tags/${id}`, tokenConfig(getState))
    .then(res => dispatch({ type: DELETE_TAG, payload: id }))
    .catch(err => dispatch(returnErrors(err.response.data, err.response.status)));
};

export const setTagsLoading = () => {
  return { type: TAGS_LOADING };
};

export const setTagLoading = () => {
  return { type: TAG_LOADING };
};

// Set current page number (without fetching data)
export const setTagsPage = (page) => {
  return { type: SET_TAGS_PAGE, payload: page };
};